import { render } from "./HotKeyColors.vue?vue&type=template&id=1e35c510"
import script from "./HotKeyColors.vue?vue&type=script&lang=js"
export * from "./HotKeyColors.vue?vue&type=script&lang=js"

import "./HotKeyColors.vue?vue&type=style&index=0&id=1e35c510&lang=css"
script.render = render

export default script